import _ from 'lodash';
import { Suspense, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useRecoilValue } from 'recoil';
import { userInfoState } from 'recoil/user/atom';
import { ROLE_TYPE } from 'types/enumType';
import { SidebarChildItemType } from 'types/sidebar';
import { decryptString } from 'util/encryptUtil';

import dashboardItemList from './dashboardItemList';
import SidebarNavItem from './SidebarNavItem';

function SidebarNavList() {
  const { pathname } = useLocation();
  const [childrenSidebarList, setChildrenSidebarList] = useState<
    SidebarChildItemType[]
  >([]);
  const userInfo = useRecoilValue(userInfoState);
  const role = decryptString(userInfo.role);

  useEffect(() => {
    const copyDashboardItemList = _.cloneDeep(dashboardItemList);
    const sidebarItem = _.cloneDeep(copyDashboardItemList).filter((item) => {
      if (item.path === 'admin' && role !== ROLE_TYPE.ADMIN) {
        return null;
      }

      if (item.path === 'loto-management') {
        let filteredChildren = _.cloneDeep(item.children);
        if (role === ROLE_TYPE.USER) {
          filteredChildren = filteredChildren.filter(
            (child) =>
              child.href !== '/loto-management/self-permission' &&
              child.href !== '/loto-management/box' &&
              child.href !== '/loto-management/permission-transfer',
          );
          item.children = filteredChildren;
        }
      }

      return pathname.includes(item.path);
    })[0];

    setChildrenSidebarList(sidebarItem?.children ?? []);
  }, [pathname, role]);

  return (
    <ul className={'lnb'}>
      <Suspense>
        {childrenSidebarList.map((item) => (
          <SidebarNavItem item={item} key={item.href} />
        ))}
      </Suspense>
    </ul>
  );
}

export default SidebarNavList;
